module.exports = __webpack_public_path__ + "fonts/ff4aabf.ttf";